window.addEventListener('load', event => {

    let shapeContainer = document.querySelector('.bg-shape-container');

    let generateRandomAmount = Math.round(Math.random() * (12 - 6) + 6);

    for(let index = 0; index < generateRandomAmount; ++index) {
        createBackgroundShapes(index);

        if ((generateRandomAmount - 1) === index) {
            let rellaxSlow = document.querySelector('.rellax-slow');
            let rellaxSlowMedium = document.querySelector('.rellax-slow-medium');
            let rellaxMedium = document.querySelector('.rellax-medium');
            let rellaxMediumFast = document.querySelector('.rellax-medium-fast');
            let rellaxFast = document.querySelector('.rellax-fast');

            if (rellaxSlow) {
                let rellaxSlow = new Rellax('.rellax-slow', {
                    speed: -1,
                });
            }
            if (rellaxSlowMedium) {
                let rellaxSlowMedium = new Rellax('.rellax-slow-medium', {
                    speed: -3,
                });
            }
            if (rellaxMedium) {
                let rellaxMedium = new Rellax('.rellax-medium', {
                    speed: -5,
                });
            }
            if (rellaxMediumFast) {
                let rellaxMediumFast = new Rellax('.rellax-medium-fast', {
                    speed: -7,
                });
            }
            if (rellaxFast) {
                let rellaxFast = new Rellax('.rellax-fast', {
                    speed: -9,
                });
            }
        }
    }

    function createBackgroundShapes(index) {
        const shapeElement = document.createElement('div');
        shapeElement.classList.add('rounded-lg', 'absolute', 'hidden', 'lg:block', 'added-background-shape');

        const windowWidth = document.body.offsetWidth;

        let shapeWidth = Math.round(Math.random() * ((windowWidth / 5) - 80) + 80);
        if (shapeWidth > 200) {
            shapeWidth = Math.round(Math.random() * ((300) - 80) + 80);
        }
        let shapeLeft = '';
        let shapeLeftCalc = '';
        if (index & 1) {
            shapeLeft = Math.random() * (50 - 25) + 25;
            shapeLeftCalc = `calc(${shapeLeft}% - 630px - ${shapeWidth}px)`
        } else {
            shapeLeft = Math.random() * (75 - 50) + 50;
            shapeLeftCalc = `calc(${shapeLeft}% + 630px)`
        }
        const shapeTop = (Math.random() * (400 - 1) + 1) * -1 - shapeWidth;
        const shapeSpeedGen = index;
        const shapeColourGen = Math.round(Math.random() * (2 - 1) + 1);
        const blurGen = Math.round(Math.random() * (3 - 1) + 1);
        const shapeOpacity = Math.round(Math.random() * (30 - 10) + 10) / 100;
        let shapeSpeed = '';
        let shapeBlur = '';
        let shapeColour = '';

        if (shapeSpeedGen === 0 || shapeSpeedGen === 5) {
            shapeSpeed = 'rellax';
        }
        else if (shapeSpeedGen === 1 || shapeSpeedGen === 6) {
            shapeSpeed = 'rellax-slow-medium';
        }
        else if (shapeSpeedGen === 2 || shapeSpeedGen === 7) {
            shapeSpeed = 'rellax-medium-fast';
        }
        else if (shapeSpeedGen === 3 || shapeSpeedGen === 8) {
            shapeSpeed = 'rellax-medium';
        }
        else {
            shapeSpeed = 'rellax-fast';
        }

        if (blurGen === 1) {
            shapeBlur = 'blur-sm';
        }
        else if (blurGen === 2) {
            shapeBlur = 'blur-md';
        }
        else {
            shapeBlur = 'blur-lg';
        }

        if (shapeColourGen == 1) {
            shapeColour = 'bg-green-brand'
        }
        else {
            shapeColour = 'bg-gray-brand'
        }

        shapeElement.style.width = shapeWidth + 'px';
        shapeElement.style.height = shapeWidth + 'px';
        shapeElement.style.opacity = shapeOpacity;
        shapeElement.style.left = shapeLeftCalc;
        shapeElement.style.top = shapeTop + 'px';
        shapeElement.classList.add(shapeSpeed, shapeBlur, shapeColour);

        shapeContainer.appendChild(shapeElement);
    }
});